import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { list } from 'actions/data'
import { ListItem, IconButton, Menu, MenuItem, Hidden } from '@material-ui/core'
import { MoreVert, Delete } from '@material-ui/icons'
import { selectUser } from 'actions/users'
// import ListView from 'components/ListView'
// import { user } from 'components/routes'
import AvatarWithLabel from 'components/Inbox/AvatarWithLabel'
import { ShieldAccount } from 'mdi-material-ui'
import { toggleDeleteDialog } from 'actions/view'
import Permissions from './Permissions'
import { DATA_API_URL } from 'utils/AllURLs'

class Users extends Component {
  state = {
    anchorEl: null,
    idx: null,
  }

  componentDidMount() {
    this.props.list('account/user', 'user_name')
    this.props.list(
      'screenpermissions',
      null,
      `${DATA_API_URL}/screenpermissions`,
    )
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userDeleted !== this.props.userDeleted) {
      this.props.list('account/user', 'user_name')
    }
  }

  handleClick = (event, idx) => {
    this.setState({ anchorEl: event.currentTarget, idx })
  }

  handleClose = () => {
    this.setState({ anchorEl: null, idx: null })
  }

  handleDeleteClick = ({ id, name }) => {
    this.setState({ anchorEl: null, idx: null })
    this.props.toggleDeleteDialog({
      id,
      name,
      entityType: 'user',
    })
  }

  render() {
    const { users } = this.props

    return (
      <div style={{ padding: 20 }}>
        {users.map((user, idx) => (
          <Fragment key={`usersList${(user && user.user_name) || idx}`}>
            <ListItem
              style={{
                backgroundColor: idx % 2 === 0 ? '#fff' : '#d5e6f8',
                borderTop: idx === 0 ? '1px solid gray' : null,
                borderLeft: '1px solid gray',
                borderRight: '1px solid gray',
                borderBottom: '1px solid gray',
                borderTopLeftRadius: idx === 0 ? 17 : null,
                borderTopRightRadius: idx === 0 ? 17 : null,
                borderBottomLeftRadius: idx === users.length - 1 ? 17 : null,
                borderBottomRightRadius: idx === users.length - 1 ? 17 : null,
                padding: '20px 20px 20px 60px',
                position: 'relative',
              }}
              onClick={() => {
                if (user && user.user_name) {
                  this.props.selectUser(user.user_name)
                } else {
                  console.log('no user name')
                }
              }}
              button
            >
              {user.user_role === 'acctowner' ? (
                <ShieldAccount
                  style={{
                    position: 'absolute',
                    fontSize: 37,
                    color: '#014c94',
                    left: 12,
                    top: '50%',
                    transform: 'translateY(-50%)',
                  }}
                />
              ) : (
                <div
                  style={{
                    position: 'absolute',
                    left: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                  }}
                >
                  <AvatarWithLabel
                    noType
                    type="user"
                    label={
                      (user &&
                        `${user.first_name ? `${user.first_name} ` : ''}${
                          user.last_name ? `${user.last_name} ` : ''
                        }`) ||
                      null
                    }
                  />
                </div>
              )}
              {(user &&
                `${user.first_name ? `${user.first_name} ` : ''}${
                  user.last_name ? `${user.last_name} ` : ''
                }`) ||
                'Unknown user'}
              {this.props.vr_role === 'acctowner' &&
              this.props.username !== user.user_name ? (
                <IconButton
                  onClick={e => {
                    e.stopPropagation()
                    this.handleClick(e, idx)
                  }}
                  style={{ position: 'absolute', right: 5 }}
                >
                  <MoreVert />
                </IconButton>
              ) : null}
              {this.props.vr_role === 'acctowner' && (
                <div
                  onClick={e => e.stopPropagation()}
                >
                  <Hidden smDown>
                    <Permissions username={user.user_name} listView />
                  </Hidden>
                </div>
              )}
            </ListItem>
            <Menu
              id={`deleteUserMenu${user?.user_name || idx}`}
              anchorEl={this.state.anchorEl}
              open={Boolean(this.state.anchorEl && this.state.idx === idx)}
              onClose={this.handleClose}
            >
              <MenuItem
                onClick={e => {
                  e.stopPropagation()
                  this.handleDeleteClick({
                    id: user.user_name,
                    name: `${user.first_name} ${user.last_name}`,
                  })
                }}
              >
                <Delete style={{ marginRight: 5 }} />
                Delete
              </MenuItem>
            </Menu>
          </Fragment>
        ))}
      </div>
    )
  }
}

export default connect(
  state => ({
    users: state.data['account/user']
      ? Object.values(state.data['account/user'])
      : [],
    loadStatus: state.loadStatus.users,
    vr_role: state.auth?.session?.idToken?.payload?.['custom:vr_role'],
    username: state.auth?.session?.idToken?.payload?.['cognito:username'],
    userDeleted: state.snackbar?.slice?.(-1)?.[0]?.detail === 'userDeleted',
  }),
  dispatch =>
    bindActionCreators({ list, selectUser, toggleDeleteDialog }, dispatch),
)(Users)
